import { useEffect, useCallback } from 'react';

const ProjectTemplateListeners = ({ eventEmitter, applyStoreAction, delayedApplyStoreAction }) => {
    const projectTemplateAdded = useCallback(payload => {
        (payload.force ? applyStoreAction : delayedApplyStoreAction)({
            type: 'PROJECT_TEMPLATE_CREATE_SOCKET',
            payload: { template: payload }
        });
    }, [applyStoreAction, delayedApplyStoreAction]);

    const projectTemplateRemoved = useCallback(({ id: templateId }) => {
        applyStoreAction({
            type: 'PROJECT_KICK_SOCKET',
            payload: {
                templateId
            }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('project_template_added', projectTemplateAdded);
        eventEmitter.on('project_template_removed', projectTemplateRemoved);

        return () => {
            eventEmitter.off('project_template_added', projectTemplateAdded);
            eventEmitter.off('project_template_removed', projectTemplateRemoved);
        };
    };

    useEffect(listen, [eventEmitter, projectTemplateAdded, projectTemplateRemoved]);

    return null;
}

export default ProjectTemplateListeners;
